export const verifyImageFile = async (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const arr = new Uint8Array(e.target.result);

            // Magic bytes dla różnych formatów
            const signatures = {
                // JPEG: FF D8 FF
                jpeg: [0xFF, 0xD8, 0xFF],
                // PNG: 89 50 4E 47 0D 0A 1A 0A
                png: [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A],
                // WebP: 52 49 46 46 ... 57 45 42 50
                webp: [0x52, 0x49, 0x46, 0x46]
            };

            // Sprawdź JPEG
            if (arr.length >= 3 &&
                arr[0] === signatures.jpeg[0] &&
                arr[1] === signatures.jpeg[1] &&
                arr[2] === signatures.jpeg[2]) {
                resolve(true);
                return;
            }

            // Sprawdź PNG
            if (arr.length >= 8 &&
                signatures.png.every((byte, i) => arr[i] === byte)) {
                resolve(true);
                return;
            }

            // Sprawdź WebP
            if (arr.length >= 12 &&
                arr[0] === signatures.webp[0] &&
                arr[1] === signatures.webp[1] &&
                arr[2] === signatures.webp[2] &&
                arr[3] === signatures.webp[3] &&
                arr[8] === 0x57 && arr[9] === 0x45 &&
                arr[10] === 0x42 && arr[11] === 0x50) {
                resolve(true);
                return;
            }

            resolve(false);
        };

        reader.onerror = () => resolve(false);

        // Odczytaj tylko pierwsze 12 bajtów
        reader.readAsArrayBuffer(file.slice(0, 12));
    });
};